@switch (regimeId) {
  @case (5) {
    <abbr title="Canada Revenue Agency">CRA</abbr>
  }
  @case (100) {
    <abbr title="Internal Revenue Service">IRS</abbr>
  }
}
